import { Option } from 'types/select';

import { ARCHES } from './prescriptionConstants';

// give translation keys here for the label
export enum PRODUCT_TYPE_VALUES {
  ZENPRO_20 = 'ZENPRO_20',
  ZENPRO_30 = 'ZENPRO_30',
  ZENPRO_UNLIMITED = 'ZENPRO_UNLIMITED'
}

export const PRODUCT_TYPE_PRO_OPTIONS: Option[] = [
  {
    value: PRODUCT_TYPE_VALUES.ZENPRO_20,
    label: 'prescriptions.zenpro20'
  },
  {
    value: PRODUCT_TYPE_VALUES.ZENPRO_30,
    label: 'prescriptions.zenpro30'
  },
  {
    value: PRODUCT_TYPE_VALUES.ZENPRO_UNLIMITED,
    label: 'prescriptions.zenprounlimited'
  }
];
export const ANGLE_CLASSIFICATION_OPTIONS: Option[] = [
  {
    value: 'Class I',
    label: 'angle_classification.class_i'
  },
  {
    value: 'Class II',
    label: 'angle_classification.class_ii'
  },
  {
    value: 'Class III',
    label: 'angle_classification.class_iii'
  },
  {
    value: 'Uncertain',
    label: 'angle_classification.uncertain'
  }
];

export const PATIENT_DIAGNOSIS_OPTIONS: Option[] = [
  {
    value: 'Flared Teeth',
    label: 'patient_diagnosis.flared_teeth'
  },
  {
    value: 'Crowding',
    label: 'patient_diagnosis.crowding'
  },
  {
    value: 'Spacing',
    label: 'patient_diagnosis.spacing'
  },
  {
    value: 'Deep Overbite',
    label: 'patient_diagnosis.deep_overbite'
  },
  {
    value: 'Deep Overjet',
    label: 'patient_diagnosis.deep_overjet'
  },
  {
    value: 'Anterior Crossbite',
    label: 'patient_diagnosis.anterior_crossbite'
  },
  {
    value: 'Posterior Crossbite',
    label: 'patient_diagnosis.posterior_crossbite'
  },
  {
    value: 'Posterior Scissors Bite',
    label: 'patient_diagnosis.posterior_scissors_bite'
  },
  {
    value: 'Open Bite',
    label: 'patient_diagnosis.open_bite'
  },
  {
    value: 'Maxillary Protrusion',
    label: 'patient_diagnosis.maxillary_protrusion'
  },
  {
    value: 'Maxiliary Insufficient Growth',
    label: 'patient_diagnosis.maxiliary_insufficient_growth'
  },
  {
    value: 'Mandibular Protrusion',
    label: 'patient_diagnosis.mandibular_protrusion'
  },
  {
    value: 'Mandibular Retrusion',
    label: 'patient_diagnosis.mandibular_retrusion'
  },
  {
    value: 'Uneven Smile',
    label: 'patient_diagnosis.uneven_smile'
  },
  {
    value: 'Gummy Smile',
    label: 'patient_diagnosis.gummy_smile'
  },
  {
    value: 'Asymmetric Deviation',
    label: 'patient_diagnosis.asymmetric_deviation'
  },
  {
    value: 'Others',
    label: 'common.others'
  }
];
export const CHIEF_COMPLAINTS = [
  {
    value: 'Flared Teeth',
    label: 'patient_diagnosis.flared_teeth'
  },
  {
    value: 'Crowding',
    label: 'patient_diagnosis.crowding'
  },
  {
    value: 'Spacing',
    label: 'patient_diagnosis.spacing'
  },
  {
    value: 'Open Bite',
    label: 'patient_diagnosis.open_bite'
  },
  { value: 'Crossbite', label: 'patient_diagnosis.crossbite' },
  {
    value: 'Posterior Scissors Bite',
    label: 'patient_diagnosis.posterior_scissors_bite'
  },
  {
    value: 'Asymmetric Deviation',
    label: 'patient_diagnosis.asymmetric_deviation'
  },
  { value: 'Others', label: 'common.others' }
];
export const MAIN_OBJECTIVES = [
  {
    value: 'Correct Flared Teeth',
    label: 'main_objectives.correct_flared_teeth'
  },
  { value: 'Align teeth', label: 'main_objectives.align_teeth' },
  { value: 'Closing space', label: 'main_objectives.closing_space' },
  { value: 'Correct Crossbite', label: 'main_objectives.correct_crossbite' },
  { value: 'Correct Open bite', label: 'main_objectives.correct_open_bite' },
  {
    value: 'Correct Posterior Scissors Bite',
    label: 'main_objectives.correct_posterior_scissors_bite'
  },
  { value: 'Others', label: 'common.others' }
];
export const ARCHES_TO_TREAT = [
  { value: ARCHES.BOTH, label: 'arches_to_treat.both' },
  { value: ARCHES.UPPER, label: 'arches_to_treat.upper' },
  { value: ARCHES.LOWER, label: 'arches_to_treat.lower' }
];
export const PASSIVE_ALIGNERS = [
  { value: 'Yes', label: 'common.yes' },
  { value: 'No', label: 'common.no' }
];
export enum TOOTH_INFORMATION {
  NONE = 'None',
  MISSING_TEETH = 'Missing teeth',
  PRIMARY_DENTITION = 'Primary Dentition'
}
export const TOOTH_INFORMATION_OPTIONS: Option[] = [
  {
    value: TOOTH_INFORMATION.MISSING_TEETH,
    label: 'tooth.Info.Missing_teeth'
  },
  {
    value: TOOTH_INFORMATION.NONE,
    label: 'none.none'
  }
];
export enum DENTITION_TYPE {
  ADULT_DENTITION = 'Adult Dentition',
  PRIMARY_DENTITION = 'Primary Dentition'
}
export const DENTITION_TYPE_OPTIONS: Option[] = [
  {
    value: DENTITION_TYPE.ADULT_DENTITION,
    label: 'dentition.adult_dentition'
  },
  {
    value: DENTITION_TYPE.PRIMARY_DENTITION,
    label: 'dentition.primary_dentition'
  }
];
export enum TOOTH_MOVEMENT_RESTRICTION {
  NONE = 'None',
  SELECT_TEETH_SHOULD_NOT_BE_MOVED = 'Selected Teeth Should not be Moved'
}
export const TOOTH_MOVEMENT_RESTRICTION_OPTIONS: Option[] = [
  {
    value: TOOTH_MOVEMENT_RESTRICTION.SELECT_TEETH_SHOULD_NOT_BE_MOVED,
    label: 'ToothMovementRestriction.should_not_move'
  },
  {
    value: TOOTH_MOVEMENT_RESTRICTION.NONE,
    label: 'none.none'
  }
];
export enum TOOTH_ATTACHMENT {
  NONE = 'None',
  NO_ATTACHMENT = 'No attachment for following teeth'
}
export const TOOTH_ATTACHMENT_OPTIONS: Option[] = [
  {
    value: TOOTH_ATTACHMENT.NONE,
    label: 'none.none'
  },
  {
    value: TOOTH_ATTACHMENT.NO_ATTACHMENT,
    label: 'ToothAttachment.no_attachment'
  }
];

export enum FACIAL_PROFILE {
  DO_NOT_CORRECT = 'Do not correct',
  IMPROVE = 'Improve (IPR or Extractions may be required)'
}
export const FACIAL_PROFILE_OPTIONS = [
  {
    value: FACIAL_PROFILE.DO_NOT_CORRECT,
    label: 'FacialProfile.do_not_correct'
  },
  {
    value: FACIAL_PROFILE.IMPROVE,
    label: 'FacialProfile.improve'
  }
];
export enum FACIAL_PROFILE_IMPROVE {
  DO_NOT_CORRECT = 'Do not correct',
  PROTRUSION = 'Improve Protrusion',
  RETRACTION = 'Improve Retraction'
}
export const FACIAL_PROFILE_IMPROVE_OPTIONS = [
  {
    value: FACIAL_PROFILE_IMPROVE.PROTRUSION,
    label: 'FacialProfile.improve.protrusion'
  },
  {
    value: FACIAL_PROFILE_IMPROVE.RETRACTION,
    label: 'FacialProfile.improve.retraction'
  },
  {
    value: FACIAL_PROFILE_IMPROVE.DO_NOT_CORRECT,
    label: 'FacialProfile.do_not_correct'
  }
];
export enum SAGITTAL_RELATIONSHIP_VALUES {
  RIGHT_AND_LEFT = 'Right and Left',
  RIGHT_OR_LEFT = 'Right or Left'
}
export enum SAGITTAL_ACTIONS_VALUES {
  DO_NOT_CORRECT = 'Do not correct',
  IMPROVE_CANINE_RELATIONSHIP = 'Improve Canine Relationship',
  IMPROVE_MOLAR_RELATIONSHIP = 'Improve Molar Relationship',
  SHOW_RESULTING_AFTER_ALIGNMENT = 'Show Resulting After Alignment'
}
export enum SAGITTAL_IMPROVE_VALUES {
  IMPROVE_ONLY = 'Improve only',
  TREATMENT_OPTION_FOR_CANINE = 'Treatment option for "Correction to Class I (canine)"',
  TREATMENT_OPTION_FOR_MOLAR = 'Treatment option for "Correction to Class I (molar)"'
}
export enum SAGITTAL_IMPROVE_SUBOPTION_VALUES {
  PRIMARILY = 'Primarily',
  AS_NEEDED = 'As needed',
  NONE = 'None'
}
export const SAGITTAL_ACTIONS_OPTIONS = [
  {
    value: SAGITTAL_ACTIONS_VALUES.DO_NOT_CORRECT,
    label: 'FacialProfile.do_not_correct'
  },
  {
    value: SAGITTAL_ACTIONS_VALUES.IMPROVE_CANINE_RELATIONSHIP,
    label: 'sagittal_relationship.improve_canine_relationship'
  },
  {
    value: SAGITTAL_ACTIONS_VALUES.IMPROVE_MOLAR_RELATIONSHIP,
    label: 'sagittal_relationship.improve_molar_relationship'
  },
  {
    value: SAGITTAL_ACTIONS_VALUES.SHOW_RESULTING_AFTER_ALIGNMENT,
    label: 'sagittal_relationship.show_resulting_after_alignment'
  }
];
export const SAGITTAL_IMPROVE_OPTIONS_CANINE = [
  {
    value: SAGITTAL_IMPROVE_VALUES.IMPROVE_ONLY,
    label: 'sagittal_relationship.improve_only'
  },
  {
    value: SAGITTAL_IMPROVE_VALUES.TREATMENT_OPTION_FOR_CANINE,
    label:
      'sagittal_relationship.treatment_option_for_correction_to_class_i_canine'
  }
];
export const SAGITTAL_IMPROVE_OPTIONS_MOLAR = [
  {
    value: SAGITTAL_IMPROVE_VALUES.IMPROVE_ONLY,
    label: 'sagittal_relationship.improve_only'
  },
  {
    value: SAGITTAL_IMPROVE_VALUES.TREATMENT_OPTION_FOR_MOLAR,
    label:
      'sagittal_relationship.treatment_option_for_correction_to_class_i_molar'
  }
];
export const SAGITTAL_IMPROVE_SUBOPTIONS = [
  {
    value: SAGITTAL_IMPROVE_SUBOPTION_VALUES.PRIMARILY,
    label: 'sagittal_relationship.suboptions.primarily'
  },
  {
    value: SAGITTAL_IMPROVE_SUBOPTION_VALUES.AS_NEEDED,
    label: 'sagittal_relationship.suboptions.as_needed'
  },
  {
    value: SAGITTAL_IMPROVE_SUBOPTION_VALUES.NONE,
    label: 'none.none'
  }
];
export const SAGITTAL_RELATIONSHIP_OPTIONS = [
  {
    value: SAGITTAL_RELATIONSHIP_VALUES.RIGHT_AND_LEFT,
    label: 'sagittal_relationship.values.right_and_left'
  },
  {
    value: SAGITTAL_RELATIONSHIP_VALUES.RIGHT_OR_LEFT,
    label: 'sagittal_relationship.values.right_or_left'
  }
];
export const OVERJET_OPTIONS = [
  {
    value: 'Show resulting overjet after alignment',
    label: 'overjet.show_resulting_overjet_after_alignment'
  },
  { value: 'Do not correct', label: 'FacialProfile.do_not_correct' },
  { value: 'Improve', label: 'common.improve' }
];
export const OVERBITE_OPTIONS = [
  {
    value: 'Show resulting overbite after alignment',
    label: 'overbite.show_resulting_overbite_after_alignment'
  },
  { value: 'Do not correct', label: 'FacialProfile.do_not_correct' },
  { value: 'Correct Open bite', label: 'overbite.correct_open_bite' },
  { value: 'Improve Deep Bite', label: 'overbite.improve_deep_bite' }
];
export const OVERBITE_CORRECT_OPEN_BITE = [
  {
    value: 'Extrude Anteriors',
    label: 'overbite.extrude_anteriors'
  },
  {
    value: 'Intrude Posterior Teeth',
    label: 'overbite.intrude_posterior_teeth'
  },
  { value: 'Others', label: 'common.others' }
];
export const ANTERIOR_BITE_RAMPS = [
  {
    value: 'Central incisor',
    label: 'overbite.central_incisor'
  },
  { value: 'Lateral incisor', label: 'overbite.lateral_incisor' },
  { value: 'Canine', label: 'overbite.canine' }
];
export const OVERBITE_IMPROVE_DEEP_BITE_UPPER = [
  {
    value: 'Anterior Intrusion',
    label: 'overbite.anterior_intrusion'
  },
  { value: 'Elevated Premolars', label: 'overbite.elevated_premolars' },
  {
    value: 'Anterior Bite Ramps',
    label: 'overbite.anterior_bite_ramps'
  },
  { value: 'Others', label: 'common.others' }
];
export const OVERBITE_IMPROVE_DEEP_BITE_LOWER = [
  {
    value: 'Anterior Intrusion',
    label: 'overbite.anterior_intrusion'
  },
  { value: 'Elevated Premolars', label: 'overbite.elevated_premolars' },
  { value: 'Others', label: 'common.others' }
];
export enum OVERBITE_OPTION_VALUES {
  SHOW_RESULTING_OVERJET_AFTER_ALIGNMENT = 'Show resulting overjet after alignment',
  DO_NOT_CORRECT = 'Do not correct',
  CORRECT_OPEN_BITE = 'Correct Open bite',
  IMPROVE_DEEP_BITE = 'Improve Deep Bite',
  ANTERIOR_BITE_RAMPS = 'Anterior Bite Ramps'
}
export const ANTERIOR_CROSSBITE_IMPROVE = [
  { value: 'Protract Upper Anterior', label: 'Protract Upper Anterior' },
  { value: 'Retract Lower Anterior', label: 'Retract Lower Anterior' }
];
export enum ANTERIOR_CROSSBITE_VALUES {
  DO_NOT_CORRECT = 'Do not correct',
  IMPROVE = 'Improve',
  CORRECT = 'Correct'
}
export const ANTERIOR_CROSSBITE = [
  { value: ANTERIOR_CROSSBITE_VALUES.DO_NOT_CORRECT, label: 'Do not correct' },
  { value: ANTERIOR_CROSSBITE_VALUES.IMPROVE, label: 'Improve' },
  { value: ANTERIOR_CROSSBITE_VALUES.CORRECT, label: 'Correct' }
];

export enum ANTERIOR_EDGE_VALUES {
  DO_NOT_CORRECT = 'Do not correct',
  CORRECT = 'Correct'
}
export const ANTERIOR_EDGE = [
  { value: ANTERIOR_EDGE_VALUES.DO_NOT_CORRECT, label: 'Do not correct' },
  { value: ANTERIOR_EDGE_VALUES.CORRECT, label: 'Correct' }
];
export const ANTERIOR_EDGE_CORRECT = [
  { value: 'Extrude Upper Anteriors', label: 'Extrude Upper Anteriors' },
  { value: 'Extrude Lower Anteriors', label: 'Extrude Lower Anteriors' },
  { value: 'Intrude Upper Posteriors', label: 'Intrude Upper Posteriors' },
  { value: 'Intrude Lower Posteriors', label: 'Intrude Lower Posteriors' }
];

export enum POSTERIOR_CROSSBITE_VALUES {
  DO_NOT_CORRECT = 'Do not correct',
  CORRECT = 'Correct'
}
export const POSTERIOR_CROSSBITE = [
  { value: POSTERIOR_CROSSBITE_VALUES.DO_NOT_CORRECT, label: 'Do not correct' },
  { value: POSTERIOR_CROSSBITE_VALUES.CORRECT, label: 'Correct' }
];
export const POSTERIOR_CROSSBITE_CORRECT = [
  { value: 'Right', label: 'Right' },
  { value: 'Left', label: 'Left' }
];
export enum MIDLINE_VALUES {
  MIDLINE_AFTER_ALIGNMENT = 'Show resulting midline after alignment',
  MAINTAIN = 'Maintain (IPR if necessary)',
  IMPROVE = 'Improve (IPR if necessary)'
}
export enum MIDLINE_IMPROVE_VALUES {
  ADJUST_PATIENT_RIGHT = 'Adjust to Patient’s Right',
  ADJUST_PATIENT_LEFT = 'Adjust to Patient’s Left',
  DO_NOT_CORRECT = 'Do not correct'
}
export const MIDLINE = [
  {
    value: MIDLINE_VALUES.MIDLINE_AFTER_ALIGNMENT,
    label: 'midline.show_resulting_midline_after_alignment'
  },
  {
    value: MIDLINE_VALUES.MAINTAIN,
    label: 'midline.maintain'
  },
  { value: MIDLINE_VALUES.IMPROVE, label: 'midline.improve' }
];
export const MIDLINE_IMPROVE = [
  {
    value: MIDLINE_IMPROVE_VALUES.ADJUST_PATIENT_LEFT,
    label: 'midline.adjust_to_patient_left'
  },
  {
    value: MIDLINE_IMPROVE_VALUES.ADJUST_PATIENT_RIGHT,
    label: 'midline.adjust_to_patient_right'
  },
  {
    value: MIDLINE_IMPROVE_VALUES.DO_NOT_CORRECT,
    label: 'FacialProfile.do_not_correct'
  }
];
export const MIDLINE_IMPROVE_ADJUST_PATIENT = [
  {
    value: '1-2mm',
    label: 'midline.1_2mm'
  },
  {
    value: 'More than 2mm',
    label: 'midline.more_than_2mm'
  }
];
export enum CROWDING_VALUES {
  AFTER_ALIGNMENT_PERFORM_IPR = 'Show resulting crowding after alignment (Accept Perform IPR)',
  AFTER_ALIGNMENT_PERFORM_EXTRACTION = 'Show resulting crowding after alignment (Accept Perform Extraction)',
  RESOLVE_CROWDING = 'Resolve Crowding'
}
export enum CROWDING_EXTRACTION_VALUES {
  NO_EXTRACTION = 'No Extraction',
  EXTRACTION = 'Extraction'
}
export enum RESOLVE_CROWDING_VALUES {
  PRIMARILY = 'Primarily',
  OPTIONAL = 'Optional',
  NONE = 'None'
}
export enum RESOLVE_CROWDING_UPPER_VALUES {
  UPPER_RIGHT = 'Upper Right',
  UPPER_LEFT = 'Upper Left'
}
export enum RESOLVE_CROWDING_LOWER_VALUES {
  LOWER_RIGHT = 'Lower Right',
  LOWER_LEFT = 'Lower Left'
}
export const CROWDING = [
  {
    value: CROWDING_VALUES.AFTER_ALIGNMENT_PERFORM_IPR,
    label: 'crowding.show_resulting_crowding_after_alignment_accept_perform_ipr'
  },
  {
    value: CROWDING_VALUES.AFTER_ALIGNMENT_PERFORM_EXTRACTION,
    label:
      'crowding.show_resulting_crowding_after_alignment_accept_perform_extraction'
  },
  {
    value: CROWDING_VALUES.RESOLVE_CROWDING,
    label: 'crowding.resolve_crowding'
  }
];
export const CROWDING_EXTRACTION = [
  {
    value: CROWDING_EXTRACTION_VALUES.NO_EXTRACTION,
    label: 'crowding.no_extraction'
  },
  {
    value: CROWDING_EXTRACTION_VALUES.EXTRACTION,
    label: 'crowding.extraction'
  }
];
export const RESOLVE_CROWDING_OPTION = [
  {
    label: 'sagittal_relationship.suboptions.primarily',
    value: RESOLVE_CROWDING_VALUES.PRIMARILY
  },
  { label: 'crowding.optional', value: RESOLVE_CROWDING_VALUES.OPTIONAL },
  { label: 'none.none', value: RESOLVE_CROWDING_VALUES.NONE }
];
export const RESOLVE_CROWDING_OPTION_UPPER = [
  {
    label: 'crowding.upper_right',
    value: RESOLVE_CROWDING_UPPER_VALUES.UPPER_RIGHT
  },
  {
    label: 'crowding.upper_left',
    value: RESOLVE_CROWDING_UPPER_VALUES.UPPER_LEFT
  },
  { label: 'none.none', value: RESOLVE_CROWDING_VALUES.NONE }
];
export const RESOLVE_CROWDING_OPTION_LOWER = [
  {
    label: 'crowding.lower_right',
    value: RESOLVE_CROWDING_LOWER_VALUES.LOWER_RIGHT
  },
  {
    label: 'crowding.lower_left',
    value: RESOLVE_CROWDING_LOWER_VALUES.LOWER_LEFT
  },
  { label: 'none.none', value: RESOLVE_CROWDING_VALUES.NONE }
];
export enum SPACING_VALUES {
  SPACING_AFTER_ALIGNMENT = 'Show resulting spacing after alignment',
  INSTRUCTIONS = 'Have preference or specific instructions'
}
export enum SPACING_INSTRUCTIONS_VALUES {
  RETRACT_ANTERIOR = 'Retract Anterior',
  RETRACT_ANTERIOR_AND_MESIALIZE_POSTERIOR = 'Retract Anterior and Mesialize Posterior',
  MESIALIZE_POSTERIOR = 'Mesialize Posterior'
}
export enum TOOTH_SPACING_VALUES {
  NO_SPACING = 'No spacing',
  LEAVE_SPACING = 'Leave spacing (mm)'
}
export const SPACING_OPTIONS = [
  {
    label: 'spacing.show_resulting_spacing_after_alignment',
    value: SPACING_VALUES.SPACING_AFTER_ALIGNMENT
  },
  {
    label: 'spacing.have_preference_or_specific_instructions',
    value: SPACING_VALUES.INSTRUCTIONS
  }
];
export const SPACING_INSTRUCTIONS_OPTIONS = [
  {
    label: 'spacing.retract_anterior',
    value: SPACING_INSTRUCTIONS_VALUES.RETRACT_ANTERIOR
  },
  {
    label: 'spacing.retract_anterior_and_mesialize_posterior',
    value: SPACING_INSTRUCTIONS_VALUES.RETRACT_ANTERIOR_AND_MESIALIZE_POSTERIOR
  },
  {
    label: 'spacing.mesialize_posterior',
    value: SPACING_INSTRUCTIONS_VALUES.MESIALIZE_POSTERIOR
  }
];
export const TOOTH_SPACING_OPTIONS = [
  {
    label: 'tooth_spacing.no_spacing',
    value: TOOTH_SPACING_VALUES.NO_SPACING
  },
  {
    label: 'tooth_spacing.leave_spacing_mm',
    value: TOOTH_SPACING_VALUES.LEAVE_SPACING
  }
];
